export var GLOBAL = {
// url: "http://138.197.102.175:3977/api/"
  //url: "http://www.appmontecarlotransvip.com:3977/api/"
   //url: "http://localhost:3977/api/"
 //url: "https://apis.sebad-r.com/api/"
 url: "https://sic.ebenezerue.edu.ec/api/"
// url: "http://sicv2.eduinclusivaec.com/api/"
};
